import { useEffect, useState } from 'react';

import { SelectChangeEvent } from '@mui/material';

import {
  ExtendedChart,
  ExtendedOptions,
  ExtendedSeriesType
} from '@/components/Chart/types/highcharts';

const useLegendDropdown = ({
  chart,
  options
}: {
  chart: ExtendedChart | null;
  options: ExtendedOptions | undefined;
}) => {
  const [selectedSeries, setSelectedSeries] = useState<ExtendedSeriesType[]>();
  const [allChartSeries, setAllChartSeries] = useState<ExtendedSeriesType[]>([]);
  useEffect(() => {
    if (!chart?.series) return;
    setAllChartSeries(chart.series.filter(series => !series.name.includes('Navigator')));
    setSelectedSeries(
      chart.series.filter(series => !series.name.includes('Navigator') && series.visible)
    );
  }, [options, chart]);

  const handleLegendItemClick = (e: SelectChangeEvent<ExtendedSeriesType[]>) => {
    const value = e.target.value;
    if (typeof value === 'object') {
      chart?.series?.map(item => {
        if (value.includes(item)) {
          item.setVisible(true);
        } else {
          item.setVisible(false);
        }
      });
      setSelectedSeries(chart?.series?.filter(item => item.visible));
    }
  };

  return { selectedSeries, allChartSeries, handleLegendItemClick };
};

export default useLegendDropdown;
